module.exports = __webpack_public_path__ + "static/media/office.adb6a888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/contact/assets/office.jpg
// module id = 418
// module chunks = 0